import { render, staticRenderFns } from "./PlanTratamentPreview.vue?vue&type=template&id=310fdf28&"
import script from "./PlanTratamentPreview.vue?vue&type=script&lang=js&"
export * from "./PlanTratamentPreview.vue?vue&type=script&lang=js&"
import style0 from "./PlanTratamentPreview.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports